export default "__VITE_ASSET__BBi0y$1m__"